import type { AmountOption, AmountOptionKey } from "./model"

/**
 * The three top-up choices (product.md §6.3): just enough to cover the
 * shortfall, ~50% extra (the default, gentle upsell), and roughly double. A
 * standalone top-up has no shortfall, so it starts from a single credit.
 */
export default function buildAmountOptions(
  shortfall: number,
  unitPriceCents: number,
  currency: string,
): readonly [AmountOption, AmountOption, AmountOption] {
  const justEnough = Math.max(1, shortfall)
  const aBitExtra = Math.max(justEnough + 1, Math.ceil(justEnough * 1.5))
  const roundUp = Math.max(aBitExtra + 1, justEnough * 2)

  const option = (key: AmountOptionKey, credits: number): AmountOption => ({
    key,
    credits,
    total: { amount: credits * unitPriceCents, currency },
  })

  return [
    option("justEnough", justEnough),
    option("aBitExtra", aBitExtra),
    option("roundUp", roundUp),
  ]
}

/** The gentle-upsell default (product.md §6.3). */
export const DEFAULT_AMOUNT_KEY: AmountOptionKey = "aBitExtra"
